import {useEffect} from 'react';

import {oneOfType, node, func} from 'prop-types';
import {useNavigate} from 'react-router-dom';

import {APP_ROUTES} from '../const';
import usePayment from '../hooks/providers/usePayment';

const RequireAccessToPaymentFeatures = ({children}) => {
  const navigate = useNavigate();
  const {hasAccessToPaymentRelatedFeatures} = usePayment();

  useEffect(() => {
    if (!hasAccessToPaymentRelatedFeatures) {
      navigate(APP_ROUTES.connections);
    }
  }, [hasAccessToPaymentRelatedFeatures]);

  return children;
};

RequireAccessToPaymentFeatures.propTypes = {
  children: oneOfType([node, func]).isRequired
};

export default RequireAccessToPaymentFeatures;
